import React from 'react';
import {
    Card,
    Row,
    Col,
    Typography,
    Table,
    Statistic,
} from 'antd';
import dayjs from 'dayjs';

const columns = [
    {
        title: 'วันที่',
        dataIndex: 'order_date',
        key: 'order_date',
        render: (text, record) => dayjs(text).format('DD-MM-YYYY')
    },
    {
        title: 'สินค้า',
        dataIndex: 'product',
        key: 'product',
        render: (text, record) => `${text?.name} ${text?.description}`,
        // width:'25%'
    },
    {
        title: 'จำนวน',
        dataIndex: 'quantity',
        key: 'quantity',
        render: (text, record) => <Statistic value={text} valueStyle={{ fontSize: 14, textAlign: 'right' }} />
    },
    {
        title: 'จำนวน',
        dataIndex: 'price',
        key: 'price',
        render: (text, record) => <Statistic value={text} precision={2} valueStyle={{ fontSize: 14, textAlign: 'right' }} />,
    },
]

function DashboardReceived({ receivedItems, quantity, price }) {
    return (
        <Card
            bordered={false}
            bodyStyle={{
                border: '1px solid #f2f2f2',
                borderRadius: "8px",
                minHeight: '350px'
            }}
        >
            <Row justify='space-between'>
                <Col>
                    <Typography.Title
                        level={4}
                        style={{
                            margin: '0px 0px 16px 0px',
                            padding: '0px',
                            // background: '#293c68',
                            // color: '#FFF',
                            // borderRadius: '8px'

                        }}
                    >
                        รายการรับสินค้า
                    </Typography.Title>
                </Col>
                <Col >
                    <Row>
                        <Col>
                            <Typography.Text
                                style={{
                                    fontSize: '18px',
                                    marginRight: '8px'
                                }}
                            >รวม</Typography.Text>
                        </Col>
                        <Col>

                            <Statistic value={quantity} valueStyle={{ fontSize: 18, textAlign: 'right', marginRight: '8px' }} />
                        </Col>
                        <Col>
                            <Typography.Text
                                style={{
                                    fontSize: '18px',
                                    marginRight: '8px'
                                }}
                            >ชิ้น</Typography.Text>
                        </Col>
                        <Col>
                            <Typography.Text
                                style={{
                                    fontSize: '18px',
                                    marginRight: '8px'
                                }}
                            >มูลค่า</Typography.Text>
                        </Col>
                        <Col>
                            <Statistic value={price.toFixed(0)} valueStyle={{ fontSize: 18, textAlign: 'right', marginRight: '8px' }} />
                        </Col>
                        <Col>
                            <Typography.Text
                                style={{
                                    fontSize: '18px'
                                }}
                            >บาท</Typography.Text>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Table
                size='small'
                rowKey={(record) => record.uid}
                columns={columns}
                dataSource={receivedItems}
                scroll={{
                    x: 1200,
                }}
            />
        </Card>
    )
}

export default DashboardReceived